// Scripts
import '../auth/auth-client'
import '../newsletters/newsletter'

// Global Styles
import '../core/styles/webflow.scss'
import '../core/styles/weglot.scss'

import { TokenDataContainer } from "../tokenData/components/tokenDataContainer";

import { ChartLegendComponent } from "../charts/historical-charts/components/chart-legend/chart-legend.component";
import { SeriesListComponent } from "../charts/historical-charts/components/chart-series/chart-series-list.component";
import { ChartRouterComponent } from "../charts/chart-router.component";
import { HistoricalChartComponent } from "../charts/historical-charts/components/charts/chart.component";
import { TimeRangeComponent } from "../charts/historical-charts/components/time-range.component/chart-time-range.component";
import { ChartTabsComponent } from "../charts/historical-charts/components/chart-tabs/chart-tabs.component";

import { NumberComponent } from "../numbers/number.component";
import { NewsComponent } from "../news/news.component";
import { NewsListComponent } from "../news/newslist.component";
import { LocalNavComponent } from "../local-nav.component";
import { DarkModeSwitcher } from '../darkMode/dark-mode-switcher.component'
import { GlobalSearchComponent } from '../global-search/components/search/global-search.component'
import { CtaComponent } from '../call-to-action/cta.component'
import { AssetScreenerComponent } from '../assetScreener/components/assetScreener.component'
import { PaymentsComponent } from '../profile/Payments/Payments.component'
import { GlobalSearchOpener } from '../global-search/components/opener/global-search-opener.component'
import { SearchHitComponent } from '../global-search/components/search-hit/search-hit.component'
import { BubbleComponent } from '../charts/bubble-chart/bubble.component'
import { PieChartComponent } from '../charts/pie-chart/pie-chart.component';
import { TableChartComponent } from '../charts/table-chart/table.component';

const registerComponents = () => {
  const components = [
    { name: 'tbw-local-nav', component: LocalNavComponent },

    { name: 'tbw-news', component: NewsComponent },
    
    { name: 'tbw-news-list', component: NewsListComponent },
    { name: 'tbw-token-data-container', component: TokenDataContainer },
    { name: 'tbw-dark-mode-switcher', component: DarkModeSwitcher },
    { name: 'tbw-asset-screener', component: AssetScreenerComponent },
    { name: 'tbw-payments', component: PaymentsComponent },
    { name: 'tbw-global-search-opener', component: GlobalSearchOpener },
    { name: 'search-hit', component: SearchHitComponent },

    { name: 'tbw-number', component: NumberComponent },
    { name: 'tbw-bubble', component: BubbleComponent },
    { name: 'tbw-pie-chart', component: PieChartComponent },
    { name: 'tbw-table-chart', component: TableChartComponent },
    { name: 'tbw-global-search', component: GlobalSearchComponent },
    { name: 'tbw-historical-chart', component: HistoricalChartComponent },
    { name: 'tbw-chart-legend', component: ChartLegendComponent },
    { name: 'tbw-chart-series', component: SeriesListComponent },
    { name: 'tbw-chart-time-range', component: TimeRangeComponent },
    { name: 'tbw-cta', component: CtaComponent },
    { name: 'tbw-chart', component: ChartRouterComponent },
    { name: 'tbw-chart-tabs', component: ChartTabsComponent },
  ]
  components.forEach(component => {
    customElements.define(component.name, component.component)
  })
}
const init = () => {
  console.log('init')
  registerComponents()
}
init()